import { render, staticRenderFns } from "./LogoLoreal.vue?vue&type=template&id=c3befba4&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\4g22\\themes\\foreground-theme-2022\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3befba4')) {
      api.createRecord('c3befba4', component.options)
    } else {
      api.reload('c3befba4', component.options)
    }
    module.hot.accept("./LogoLoreal.vue?vue&type=template&id=c3befba4&", function () {
      api.rerender('c3befba4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/svg/LogoLoreal.vue"
export default component.exports